// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__emTve","animation":"layout_animation__f8LtJ","backgroundchange":"layout_backgroundchange__Sustu","content":"layout_content__8yNkj"};